if(!__webpack_require__.federation){
	__webpack_require__.federation = {
		initOptions: {"name":"suite_shell","remotes":[],"shareStrategy":"version-first"},
		chunkMatcher: function(chunkId) {return true},
		rootOutputDir: "",
		initialConsumes: undefined,
		bundlerRuntimeOptions: {}
	};
}